import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-by-invitation-access-section',
  standalone: false,
  templateUrl: './by-invitation-access-section.component.html',
  styleUrl: './by-invitation-access-section.component.scss',
})
export class ByInvitationAccessSectionComponent {
  @Input() 
  isCourse: boolean = false;
}
